import React from 'react'
import TabsProvider from '../../tabs-provider'

const ShowPage = ({ params: { cmsPageId }, location, children }) => (
  <div>
    <TabsProvider
      pathname={location.pathname}
      tabs={[{
        label: 'Edit Page',
        path: `/cms/pages/${cmsPageId}/edit`
      }, {
        label: 'Header',
        path: `/cms/pages/${cmsPageId}/header`
      }, {
        label: 'Blocks',
        path: `/cms/pages/${cmsPageId}/blocks`
      }]}
    />
    {children}
  </div>
)

export default ShowPage
